export interface ILink {
  url: string;
  title: string;
}

export const HEADER_LINKS: ILink[] = [
  { url: '/', title: 'Home' },
  { url: '/careers', title: 'Careers' }
];

export const FOOTER_LINKS: ILink[] = [
  { title: 'Privacy & Security', url: 'http://www.goldmansachs.com/privacy_policy/index.html' },
  {
    title: 'Learn More About Cookies',
    url: 'http://www.goldmansachs.com/privacy-and-security/cookies.html'
  },
  { title: 'goldmansachs.com', url: 'http://www.goldmansachs.com/' },
  { title: 'Contact Sales', url: 'mailto:marquee@gs.com' }
];

/**
 * Path of the Marquee IBD ECM Investor app
 */
export const IBD_AUCTIONS_URL_PATH = 'ecminvestor';

/**
 * Header links specific to IBD ECM Investor
 */
export const IBD_AUCTIONS_HEADER_LINKS: ILink[] = [];

/**
 * Footer links specific to IBD ECM Investor.
 * The URLs here should be relative to the domain and start with '/'
 */
export const IBD_AUCTIONS_FOOTER_LINKS: ILink[] = [
  {
    title: 'Privacy Policy',
    url: '/resources/ibd-investor/privacy-policy.pdf'
  }
];
